const defaultSlider = {
  slidesPerView: 5,
  slidesPerColumn: 1,
  navigation: true,
  navigationStyle: 1,
  pagination: false,
  paginationStyle: 1,
  autoplay: false,
  loop: false,
  spaceBetween: 16
};

export { defaultSlider };
